import {ClientType} from "@/apps/base/api/BaseRepository";
import {SwaggerRepository} from "@/apps/talent-api/api/swagger";

export default {
    swagger: new SwaggerRepository(),
}